angular.module('unergie.main')
.directive('userInfoAccountSmallBusinessInfo', ($state, $uibModal, $filter, AlertManager, DataAccess, ApiUser,
    AddrService, BoFeaturesService, AdminComments, MetaWatcher, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/account/userInfoAccountSmallBusinessInfo.html',
        link($scope) {
            const feats = BoFeaturesService.getModuleFeatures('accountinfo')
            $scope.displayField = BoFeaturesService.fieldTester('accountinfo')
            $scope.mailDeliveryOk = true
            $scope.isLoadingSmallBusinessInfo = false

            MetaWatcher.watch('DELIVERY_STATUS', 'userInfoAccountSmallBusinessInfo', $scope, (status) => {
                $scope.mailDeliveryOk = status
            })

            // CONTACTS
            const mobilePhoneRegex = /^\+33[6-7]\d{8}$/
            const landlinePhoneRegex = /^\+33([1-59]\d{8}|80\d{7})$/
            const newPhoneTemplate = { value: '' }
            $scope.newPhonePayload = _.assign({}, newPhoneTemplate, { id_account: $scope.account.id })
            $scope.newPhoneFields = {
                value: {
                    required: true,
                    label: 'Numéro',
                    type: 'phone-international',
                },
            }
            const newMailTemplate = { value: '' }
            $scope.newMailPayload = _.assign({}, newMailTemplate, { id_account: $scope.account.id })
            $scope.newMailFields = {
                value: {
                    required: true,
                    label: 'Email',
                    type: 'email',
                },
            }

            $scope.isAIFeatureOn = (feature) => feats[feature]

            $scope.hasBillingAccount = () => $scope.account && $scope.account.billingaccount && Object.keys($scope.account.billingaccount).length > 0

            $scope.updateMainContact = false
            $scope.saveMainContact = () => {
                const payload = {
                    civ: $scope.account.civ,
                    sn: $scope.account.sn.trim(),
                    givenname: $scope.account.givenname.trim(),
                }

                return ApiUser.updateAccount({ id_account: $scope.account.id }, payload).$promise.then(() => {
                    AlertManager.success('Contact principal modifié')
                    const comment = `<b>AUTOMATIQUE</b> : Contact principal mis à jour : <b>${$scope.account.civ} ${$scope.account.sn} ${$scope.account.givenname}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.toggleUpdateMainContact()
                    $scope.refreshAccount()
                }).catch(ErrorCatcher)
            }

            $scope.toggleUpdateMainContact = () => {
                $scope.updateMainContact = !$scope.updateMainContact
            }

            // CHANGE EMAIL
            $scope.onEmailChange = function (newMail, process) {
                if (process === false) {
                    return $scope.refreshAccount()
                }
            }

            // CONTACTS
            $scope.additionalPhones = () => _.filter($scope.account.contacts, (c) => (c.contact_type === 'mobilephone') || (c.contact_type === 'landline') || (c.contact_type === 'internationalphone'))

            $scope.deleteAdditionalPhone = (phone) =>
                DataAccess.deleteContact({ id: phone.id }).$promise.then((result) => {
                    AlertManager.success('Numéro supprimé.')
                    const comment = `<b>AUTOMATIQUE</b> : Numéro supprimé <b>${$filter('phone')(phone.value)}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    return $scope.refreshAccount() }).catch(ErrorCatcher)


            $scope.addAdditionalPhone = function () {
                if ($scope.newPhonePayload.value.match(mobilePhoneRegex) !== null) {
                    $scope.newPhonePayload.contact_type = 'mobilephone'
                } else if ($scope.newPhonePayload.value.match(landlinePhoneRegex) !== null) {
                    $scope.newPhonePayload.contact_type = 'landline'
                } else {
                    $scope.newPhonePayload.contact_type = 'internationalphone'
                }
                return DataAccess.addContact($scope.newPhonePayload).$promise.then((result) => {
                    AlertManager.success('Numéro ajouté.')
                    const comment = `<b>AUTOMATIQUE</b> : Numéro ajouté <b>${$filter('phone')($scope.newPhonePayload.value)}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.newPhonePayload = _.assign({}, newPhoneTemplate, { id_account: $scope.account.id })
                    return $scope.refreshAccount() }).catch(ErrorCatcher)
            }

            $scope.additionalMails = () => _.filter($scope.account.contacts, (c) => c.contact_type === 'genericmail')

            $scope.deleteAdditionalMail = (mail) =>
                DataAccess.deleteContact({ id: mail.id }).$promise.then((result) => {
                    AlertManager.success('Email supprimé.')
                    const comment = `<b>AUTOMATIQUE</b> : Email supprimé <b>${mail.value}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    return $scope.refreshAccount() }).catch(ErrorCatcher)


            $scope.addAdditionalMail = function () {
                $scope.newMailPayload.contact_type = 'genericmail'
                return DataAccess.addContact($scope.newMailPayload).$promise.then((result) => {
                    AlertManager.success('Email ajouté.')
                    const comment = `<b>AUTOMATIQUE</b> : Email ajouté <b>${$scope.newMailPayload.value}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.newMailPayload = _.assign({}, newMailTemplate, { id_account: $scope.account.id })
                    return $scope.refreshAccount() }).catch(ErrorCatcher)
            }

            $scope.formatPhone33To06 = function (phone) {
                if (phone && (phone.indexOf('+33') === 0)) {
                    return `0${phone.slice(3)}`
                }
                return phone
            }

            const formatAddress = function (a) {
                let addr = `${a.addr_num_street} `
                addr += `${a.addr_city_lbl} (`
                addr += `${a.addr_post_code})`
                if (a.addr_bat) {
                    addr += ` BAT : ${a.addr_bat}`
                }
                if (a.addr_details) {
                    addr += ` - ${a.addr_details}`
                }
                if (a.addr_locality) {
                    addr += ` - ${a.addr_locality}`
                }
                return addr
            }

            // CHANGE BILLING ADDRESS
            $scope.openBillingAddrModal = function () {
                $scope.account.billingaccount.id_account = $scope.account.id
                return AddrService.openAddrModal('billingAccount', $scope.account.billingaccount, (result) => {
                    if (result) {
                        let comment = '<b>AUTOMATIQUE</b> : Adresse de facturation modifiée :'
                        comment += `<br>Ancienne : <b>${formatAddress($scope.account.billingaccount)}</b>`
                        comment += `<br>Nouvelle : <b>${formatAddress(result)}</b>`
                        AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                        return $scope.refreshAccount()
                    }
                })
            }

            // UPDATE BUSINESS INFO

            $scope.updateBusinessInfo = false
            $scope.toggleBusinessInfo = () => {
                $scope.updateBusinessInfo = !$scope.updateBusinessInfo
            }

            $scope.saveBusinessInfo = () => {
                const payload = {
                    siret: $scope.account.siret,
                    legal_name: $scope.account.legal_name,
                    business_code: $scope.account.business_code,
                }
                return ApiUser.updateAccount({ id_account: $scope.account.id }, payload).$promise.then(() => {
                    AlertManager.success('Informations de la société modifiées')
                    const comment = `<b>AUTOMATIQUE</b> : Informations de la société mises à jour : <b>Siret : ${$scope.account.siret}, Raison sociale : ${$scope.account.legal_name}, Code NAF : ${$scope.account.business_code}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.toggleBusinessInfo()
                    $scope.refreshAccount()
                }).catch(ErrorCatcher)
            }

            $scope.refreshSmallBusinessInfo = () => {
                $scope.errorMessage = undefined
                if ($scope.account.siret && $scope.account.siret.length === 14) {
                    $scope.isLoadingSmallBusinessInfo = true
                    ApiUser.validateSiret({ siret: $scope.account.siret })
                    .$promise.then((companyInformation) => {
                        $scope.account.legal_name = companyInformation.legal_name
                        $scope.account.business_code = companyInformation.business_code
                        $scope.account.siret = companyInformation.siret
                        $scope.saveBusinessInfo()
                    })
                    .catch((error) => {
                        $scope.account.legal_name = undefined
                        $scope.account.business_code = undefined
                        if (error.status === 404) {
                            $scope.errorMessage = `Le SIRET n'a pas été trouvé dans la base de l'INSEE.`
                        } else {
                            return ErrorCatcher(error)
                        }
                    })
                    .finally(() => {
                        $scope.isLoadingSmallBusinessInfo = false
                    })
                } else {
                    $scope.errorMessage = `Le SIRET doit avoir 14 caractères.`
                }
            }
        },
    })
)
